// Libraries
import { useTranslation } from "react-i18next";
import { generatePath, Link } from "react-router-dom";

// Components
import { ArrowRight, CheckCircle } from "@untitled-ui/icons-react";
import { ButtonV2 } from "#src/commonV2/Button";
import { ModalHeaderIcon } from "#src/commonV2/modal/ModalHeaderIcon";
import { ModalV2 } from "#src/commonV2/modal/ModalV2";

interface PaymentSuccessModalProps {
  workspaceId: string;
  open: boolean;
  onChangeOpen: (value: boolean) => void;
  settingPath: string;
  paymentType?: string;
}

const PaymentSuccessModal = ({
  workspaceId,
  open,
  onChangeOpen,
  settingPath,
  paymentType,
}: PaymentSuccessModalProps) => {
  const translationKey =
    paymentType === "addKeyword" ? "dataLeak" : "trustCenter";
  const keyPrefix =
    paymentType === "addKeyword"
      ? "addKeyword.payment.successModal"
      : "registerDomain.payment.successModal";

  const { t } = useTranslation(translationKey, {
    keyPrefix: keyPrefix,
  });

  return (
    <ModalV2
      open={open}
      onChangeOpen={onChangeOpen}
      className="pt-[4.5rem] w-[34rem]"
    >
      <div className="flex flex-col items-center gap-5">
        <ModalHeaderIcon type="success" Icon={CheckCircle} />
        <span className="text-lg font-semibold text-gray-v2-900">
          {t("paymentSuccess")}
        </span>
        <span className="text-md text-center w-[24rem]">
          {t("instruction")}
        </span>
        <Link
          to={generatePath(settingPath, {
            workspaceId,
          })}
        >
          <ButtonV2>
            {t("button.backToConfig")}
            <ArrowRight className="h-5 w-5 min-w-5" />
          </ButtonV2>
        </Link>
      </div>
    </ModalV2>
  );
};

export default PaymentSuccessModal;
